import { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
import { logout } from '../../actions/authActions';
import GenericIcons from '../generics/GenericIcons';

interface IProps {
  logout: typeof logout;
  className: string;
  icon: string;
  textLogout: string;
}

const Logout: FunctionComponent<IProps> = ({ logout, className, icon, textLogout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // Botón real para que cerrar sesión funcione también con teclado. tabIndex explícito: el menú
  // del avatar (MUI MenuList) solo recorre con flechas los elementos que tienen el atributo.
  return (
    <button
      type='button'
      className={className}
      onClick={handleLogout}
      tabIndex={0}
      aria-label={textLogout || 'Cerrar sesión'}>
      <GenericIcons icon={icon} imageStyle={{ height: '100%' }} />
      {textLogout}
    </button>
  );
};

export default connect(null, { logout })(Logout);
